/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles
 */

export { default as Bold } from './bold';
export { default as BoldEditing } from './bold/boldediting';
export { default as BoldUI } from './bold/boldui';
export { default as Code } from './code';
export { default as CodeEditing } from './code/codeediting';
export { default as CodeUI } from './code/codeui';
export { default as Italic } from './italic';
export { default as ItalicEditing } from './italic/italicediting';
export { default as ItalicUI } from './italic/italicui';
export { default as Strikethrough } from './strikethrough';
export { default as StrikethroughEditing } from './strikethrough/strikethroughediting';
export { default as StrikethroughUI } from './strikethrough/strikethroughui';
export { default as Subscript } from './subscript';
export { default as SubscriptEditing } from './subscript/subscriptediting';
export { default as SubscriptUI } from './subscript/subscriptui';
export { default as Superscript } from './superscript';
export { default as SuperscriptEditing } from './superscript/superscriptediting';
export { default as SuperscriptUI } from './superscript/superscriptui';
export { default as Underline } from './underline';
export { default as UnderlineEditing } from './underline/underlineediting';
export { default as UnderlineUI } from './underline/underlineui';
